<template>
 <div class="suggestions" @keydown="onSuggestionsKeydown">
    <ul class="divide-y" role="listbox" >
    <li v-if="isEnableTaia">
    <button
        @mousedown.prevent.stop="openIframeChat"
        role="option"
        class="w-full text-left"
    >
        <Search-entry-gpt />
    </button>
    <hr />
    </li>
    <li v-for="(result, index) in props.searchSuggestions" :key="result">
    <NuxtLink
        :id="`option-${index}`"
        role="option"

        class="flex items-center gap-[16px] text-left p-[8px] hover:bg-gray-300 hover:text-gray-700"
        :to="`/search?q=${props.query}#${result.toLowerCase()}`"
        :aria-label="`View results for ${result}`"
        external
    >
        <Icon class="w-[16px] h-[16px]" :icon="`${getCategoryIconClass(result)}`"/>
        <div class="font-normal text-[14px] leading-[160%] whitespace-nowrap">
        {{ result }}
        </div>
    </NuxtLink>
    </li>
</ul>
    </div>
</template>

<script setup lang="tsx">
import Icon from '~/components/ui/atom/icon.vue'
import SearchEntryGpt from "~/components/ui/molecule/gpt/searchEntryGpt.vue";
import { defineEmits ,onMounted, onBeforeUnmount } from 'vue';
import { useIframeStore } from '@/stores/chatAIStore';
import { storeToRefs } from 'pinia';

interface SearchSuggestionCategoryProps {
    query: string
    searchSuggestions: string[]
}

const props = defineProps<SearchSuggestionCategoryProps>();

const iframeStore = useIframeStore();
const { inputSearchQuery, isEnableTaia} = storeToRefs(iframeStore);
const emit = defineEmits<{
      (e: 'clear-search-results'): void
    }>()
const openIframeChat = () => {
    emit('clear-search-results')
    iframeStore.sendMessageToChatbot('queryChat',{
        currentMinimise: false,
        searchQuery: inputSearchQuery.value
    })
};

function getCategoryIconClass(categoryName: string) {
    switch (categoryName) {
        case "Products":
            return "capsules"
        case "Articles":
            return "newspaper"
        case "Videos":
            return "video"
        case "Ingredients":
            return "mortar-pestle"
        case "Resources":
        case "Affiliates":
        case "Podcasts":
        default:
            return "book"
    }
}

function onSuggestionsKeydown(event: KeyboardEvent) {
  const container = document.querySelector('.suggestions') as HTMLElement | null
  if (!container) return
  const links = Array.from(
    container.querySelectorAll<HTMLElement>('[role="option"]')
  )
  if (!links.length) return
  const activeElement = document.activeElement as HTMLElement | null
  let currentIndex = links.findIndex(link => link === activeElement)
  if (currentIndex === -1) {
    currentIndex = 0
  }
  switch (event.key) {
    case 'ArrowDown': {
      event.preventDefault()
      if (activeElement?.id === 'base-input') {
        links[0]?.focus()
        return
      }

      const next = (currentIndex + 1) % links.length
      links[next]?.focus()
      break
    }
    case 'ArrowUp': {
      event.preventDefault()

      if (activeElement?.id === 'base-input') {
        links[links.length - 1]?.focus()
        return
      }
      const prev = (currentIndex - 1 + links.length) % links.length
      links[prev]?.focus()
      break
    }
    case 'Escape':
      event.preventDefault()
      emit('clear-search-results')
      const input = document.querySelector('#base-input') as HTMLElement | null
      input?.focus()
      break
    case 'Tab': {
      event.preventDefault()
      if (event.shiftKey) {
        links[currentIndex <= 0 ? links.length - 1 : currentIndex - 1]?.focus()
      } else {
        links[currentIndex === links.length - 1 ? 0 : currentIndex + 1]?.focus()
      }
      break
    }
  }
}

</script>
